import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useI18n } from '../../i18n/i18nService';
import ThemeToggle from "../../components/ThemeToggle";
import { ButtonCustom, FormError, OtpField } from '../../components/common/Form';
import { useAuth } from '../../contexts/AuthContext';

const OtpVerificationPage = () => {
    const { t } = useI18n(['auth']);
    const { verifyOtp, resendOtp } = useAuth();
    const navigate = useNavigate();
    const initialCount = parseInt(localStorage.getItem('otpResendCount') || '0', 10);
    const computeDelay = (count) => {
        switch (count) {
            case 0: return 30;
            case 1: return 60;
            case 2: return 180;
            case 3: return 300;
            default: return 600; // toutes les suivantes : 10 min
        }
    };
    const location = useLocation();
    const phone = location.state?.phone || null;
    const [otp, setOtp] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [resendTimeout, setResendTimeout] = useState(computeDelay(initialCount));
    const [timeLeft, setTimeLeft] = useState(resendTimeout);
    const [resendCount, setResendCount] = useState(0); // compteur de resend

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setTimeout(() => setTimeLeft((prev) => prev - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [timeLeft]);



    const handleResend = async () => {
        if (timeLeft > 0) return;
        // Appelle ton service d'envoi OTP ici
        try {
            await resendOtp(phone);
            const nextCount = resendCount + 1;
            const nextTimeout = computeDelay(nextCount);

            setResendCount(nextCount);
            setResendTimeout(nextTimeout);
            setTimeLeft(nextTimeout);
            localStorage.setItem('otpResendCount', nextCount.toString());
        } catch (error) {
            setError(t(`auth:errors.otp.${error.status || 500}`));
        }
    };

    const handleVerify = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            // TODO: Remplace avec ton service de vérif OTP
            await verifyOtp({ phone, code: otp });
            localStorage.removeItem('otpResendCount');
            navigate('/define-password', { state: { phone  }, replace: false });
            setOtp('');
        } catch (err) {
            setError(t(`auth:errors.otp.${err.status || 500}`));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-light-background dark:bg-dark-background px-4">
            <div className="max-w-md w-full p-6 rounded-lg shadow-lg bg-white dark:bg-gray-800">
                <div className="flex justify-center items-center mb-4">
                    <img
                        src="/images/logo.png" // Assurez-vous que le chemin est correct
                        alt="IDARAF"
                        className="h-28 w-28 object-contain rounded-full border border-light-tertiary/20 dark:border-dark-tertiary/20 p-1 dark:bg-gray-50"
                    />
                </div>
                <h2 className="text-2xl font-bold mb-4 text-center text-light-text dark:text-dark-text">
                    {t('auth:otp_verification')}
                </h2>
                <p className="text-sm text-center text-gray-600 dark:text-gray-300 mb-6">
                    {t('auth:otp_sent_to')} <strong>{phone}</strong>
                </p>

                {error && <FormError message={error} />}

                <form onSubmit={handleVerify} className="space-y-4 mt-4">
                    <OtpField
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        disabled={loading}
                        error={!!error}
                        autoFocus={false}
                    />

                    <ButtonCustom
                        type="submit"
                        variant="primary"
                        className="w-full py-2 px-4 rounded-md text-white font-semibold"
                        loading={loading}
                        disabled={loading || otp.length < 6}
                    >
                        {t('auth:verify')}
                    </ButtonCustom>
                    {otp.length === 6 && !loading && !error && (
                        <div className="text-light-primary dark:text-dark-primary text-xs text-center mt-2">✓ {t("auth:otp_ready")}</div>
                    )}
                    <div className="flex justify-between items-center mt-4">
                        {timeLeft > 0 ? (
                            <div className="text-xs text-gray-600 dark:text-gray-400  ">
                                <span>
                                    {`${t('auth:resend_otp_in')} ${timeLeft}s : ${t('auth:resend_otp')}`}
                                </span>
                            </div>
                        )
                            : (
                                <div className="text-xs text-gray-600 dark:text-gray-400  ">
                                    {t('auth:did_not_receive_code')}{' '}
                                    <button type="button" onClick={handleResend} className="text-light-primary dark:text-dark-primary hover:underline">
                                        {t('auth:resend_otp')}
                                    </button>
                                </div>
                            )}

                        <ThemeToggle />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default OtpVerificationPage;
